<div class="kodit-card-tab">
  <kodit-racun-saldo
    [vrstaRacuna]="VrstaRacuna.ULAZNI"
    [tipRacuna]="selectedTipRacuna"
  ></kodit-racun-saldo>

  <div class="p-mt-3">
    <p-tabView
      [(activeIndex)]="activeIndex"
      (activeIndexChange)="handleIndexChange($event)"
    >
      <p-tabPanel header="Fakture"></p-tabPanel>
      <p-tabPanel header="Avansni računi"></p-tabPanel>
      <p-tabPanel header="Dokumenti o smanjenju"></p-tabPanel>
      <p-tabPanel header="Dokumenti o povećanju"></p-tabPanel>
      <p-tabPanel header="Kompenzacije" *ngIf="!hasBesplatniPaket"></p-tabPanel>
      <p-tabPanel header="SEF" *ngIf="!jeFizickoLice"></p-tabPanel>
    </p-tabView>
  </div>
  <div [ngSwitch]="activeIndex">
    <div *ngSwitchCase="0">
      <kodit-racun-table
        [tipRacuna]="tipUlaznaFaktura"
        [vrstaRacuna]="vrstaRacunaUlazni"
      ></kodit-racun-table>
    </div>
    <div *ngSwitchCase="1">
      <kodit-racun-table
        [tipRacuna]="tipAvansniRacun"
        [vrstaRacuna]="vrstaRacunaUlazni"
      ></kodit-racun-table>
    </div>
    <div *ngSwitchCase="2">
      <kodit-racun-table
        [tipRacuna]="tipOdobrenje"
        [vrstaRacuna]="vrstaRacunaUlazni"
      ></kodit-racun-table>
    </div>
    <div *ngSwitchCase="3">
      <kodit-racun-table
        [tipRacuna]="tipZaduzenje"
        [vrstaRacuna]="vrstaRacunaUlazni"
      ></kodit-racun-table>
    </div>
    <div *ngIf="hasBesplatniPaket">
      <div *ngSwitchCase="4">
        <kodit-neobradjen-sef-racun-table *ngIf="!jeFizickoLice" [strankaPib]="strankaPib"></kodit-neobradjen-sef-racun-table>
      </div>
    </div>
    <div *ngIf="!hasBesplatniPaket">
      <div *ngSwitchCase="4">
        <kodit-kompenzacija-table></kodit-kompenzacija-table>
      </div>
      <div *ngSwitchCase="5">
        <kodit-neobradjen-sef-racun-table *ngIf="!jeFizickoLice" [strankaPib]="strankaPib"></kodit-neobradjen-sef-racun-table>
      </div>
    </div>
  </div>
</div>
